import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import PneuFabricanteSelector from "../../components/pneus/pneuFabricanteSelector";
import PneuModeloSelector from "../../components/pneus/pneuModeloSelector";
import PneuMedidaSelector from "../../components/pneus/pneuMedidaSelector";
import BandaSelector from "../../components/pneus/bandaSelector";
import {getServiceOrderDetail, postOSHeader} from "../../actions/orderActions";
import {useDispatch, useSelector} from "react-redux";
import {Select} from "@material-ui/core";
import clsx from "clsx";
import Typography from "@material-ui/core/Typography";
import {useDebounce} from "use-debounce";

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: theme.spacing(1) * 10,
    width: '100%'
  },
  relative: {
    position: 'relative'
  },
  textControl : {
    paddingTop: 0,
    paddingBottom: 5,
  },
  switchControl : {
    width: 58,
    height: 38,
    display: 'inline-flex',
    padding: 12,
    zIndex: 0,
    overflow: 'hidden',
    position: 'relative',
    boxSizing: 'border-box',
    flexShrink: 0,
    verticalAlign: 'middle',
    paddingBottom: 5,
  },
  tableTextField: {
    width: '100%',
    '& fieldset': {
      borderRadius: '0'
    },
    '& input': {
      padding: '20px'
    }
  },
  row: {
    marginBottom: theme.spacing(1),
  }
}));

const OrdemServicoAdd = ({
                              isOpen,
                              selectedRow,
                             closeDialog

}) => {

  const classes = useStyles();
  const [open, setOpen] = React.useState(isOpen);
  const [osCodigo, setOrderId] = React.useState('');
  const [osCodigoDebounced] = useDebounce(osCodigo, 1500);
  const [processo, setProcesso] = React.useState(1);
  const [marca, setMarca] = React.useState('');
  const [modelo, setModelo] = React.useState('');
  const [banda, setBanda] = React.useState('');
  const [medida, setMedida] = React.useState('');
  const [descricao, setDescricao] = React.useState('');
  const [dot, setDot] = React.useState('');
  const [marcaFogo, setMarcaFogo] = React.useState('');
  const  processos = useSelector( state =>  state.i4.processos);
  const  orderDetails = useSelector( state =>  state.ordemServicoReducer.ordemServico);
  const estabId = useSelector( state => state.filter.estabelecimentoId );
  const [msg, setMsg] = useState('');
  const [msgButton, setMsgButton] = useState('');
  const [modoAtualizacao,setModoAtualizacao] = useState(1);
  const dispatch = useDispatch();



    useEffect( () => {
       setModoAtualizacao(1)
    }, [  ]);

    useEffect( () => {
        switch (modoAtualizacao) {
            case 1:
                setMsg("Criar OS especial negativa. (Sem código de barras na ficha ERP).")
                setMsgButton("NOVA OS ESPECIAL -X ");
                break;
            case 2:
                setMsg(`Editar OS ${orderDetails.ordemServicoId} existente`);
                setMsgButton("ALTERAR DADOS");
                break;
            case 3:
                setMsg("Criar OS com código de barras. (Ficha nao importada do ERP.)");
                setMsgButton("NOVA OS")
                break
        }

    }, [ modoAtualizacao ]);



    useEffect( () => {
    setOpen(isOpen);
    // console.log("useEffect 1", isAddNewRecord, addNewRecord, open, isOpen);
  }, [ isOpen ]);

  useEffect(() => {
    if(orderDetails && orderDetails.id){

       //console.log("useEffect alterando de orderDetails");
       setModoAtualizacao(2)

     //   console.log("useEffect orderDetails", orderDetails.ordemServicoId);
        setOrderId(orderDetails.ordemServicoId);

       setMarca(orderDetails.pneuModelo.pneuFabricanteId);
       setModelo(orderDetails.pneuModeloId);

       setBanda(orderDetails.bandaId);
       setMedida(orderDetails.pneuMedidaId);
       setDot(orderDetails.dot);
       setMarcaFogo(orderDetails.marcaFogo);
       setProcesso(orderDetails.processoId);
    }
  }, [orderDetails]);

    useEffect( () => {
      //  console.log("useEffect debounced", osCodigoDebounced);
        if (typeof osCodigoDebounced !== "undefined" && osCodigoDebounced !== '') {
        //    console.log("useEffect debounced dispatch", osCodigoDebounced);
            dispatch(getServiceOrderDetail(osCodigoDebounced));
        }
        if (osCodigoDebounced === '') {
            setModoAtualizacao(1); // criar OS especial

        } else {
            setModoAtualizacao(3); // criar OS com codigo de barras
        }
    }, [ osCodigoDebounced ]);



  const handleClose = () => {
      closeDialog();
  };


  const resetForm = () => {
      setDescricao('');
      setMarcaFogo('');
      setDot('');
      setMarca('');
      setModelo('');
      setBanda('');
      setMedida('');
  };

 // botao Novo
 const handleSaveNew = async() => {
        let mId: any = marca;
        if (marca && marca.id) { mId = marca.id; }
        let modId: any = modelo;
        if (modelo && modelo.id) { modId = modelo.id; }
        let medId: any = medida;
        if (medida && medida.id) { medId = medida.id; }
        let banId : any = banda;
        if (banda && banda.id) { banId = banda.id; }
        let dados = {
          estabelecimentoId:  estabId,
          ordemServicoId: osCodigo,
          marca: mId,
          pneuModeloId : modId,
          pneuMedidaId : medId,
          bandaId: banId,
          dot: dot,
          marcaFogo: marcaFogo,
          observacoes: descricao,
          statusOrdemServicoId: 1,
          processoId: processo
        }
        if(orderDetails && orderDetails.id){
            dados = {
                ...dados,
                id: orderDetails.id
            }
        } else {
            dados = {
                ...dados,
                dtChegada: new Date().toISOString()
            }
        }
        console.log("addform dados", dados);
        dispatch(postOSHeader(dados));


        setOrderId('');
        resetForm();
     closeDialog();
        //closeDialog();
    }



    const alteraMarca = (e) => {
      setMarca(e)
}

 let mId: any = marca;
 if (marca.id) { mId = marca.id; }

 let modId: any = modelo;
 if (modelo.id) { modId = modelo.id; }

 let medId: any = medida;
 if (medida.id) { medId = medida.id; }

 let banId : any = banda;
 if (banda.id) { banId = banda.id; }


  return (
    <div>
      <Dialog fullWidth maxWidth={'md'} scroll="body" open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Adicionar | Editar Ordem Servico</DialogTitle>

          <DialogContent>
          <Grid item xs={12} container spacing={3}>

            <Grid item xs={12} md={12}  lg={12} xl={12} container>
              <Grid item xs={12} md={12} lg={12} xl={12}  className={classes.row} container>
                    <Grid item xs={10} md={10}  lg={10} xl={10} container>
                  <FormControl className={classes.formControl}>
                    <InputLabel shrink htmlFor="order-label-placeholder" className={ classes.relative}>
                      Num. Ordem Servico
                    </InputLabel>
                    <TextField
                      autoFocus
                      id="order"
                      label=""
                      type="text"
                      onChange={(e) => setOrderId(e.target.value)}
                      value={osCodigo}
                      className={classes.textControl}
                    />
                      <InputLabel shrink htmlFor="order-label-placeholder" className={ classes.relative} style={{color:'red'}}>
                          {msg}
                      </InputLabel>
                  </FormControl>
                </Grid>
                  <Grid item xs={12} md={12}  lg={2} xl={2} container>
                      <FormControl className={classes.formControl}>
                          <InputLabel htmlFor="age-native-simple">Processo</InputLabel>
                          <Select
                              native
                              value={processo}
                              onChange={(e) => setProcesso(e.target.value)}
                              inputProps={{
                                  name: 'processo',
                                  id: 'processoSelect',
                              }}
                          >
                              <option aria-label="Selecione" value="" />
                              { processos.map( (p, ix) => {
                                  return (<option key={ix} value={p.id}>{p.descricao}</option>)
                              })};
                          </Select>
                      </FormControl>
                  </Grid>
              </Grid>


              <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl}>
                          <PneuFabricanteSelector
                                    //todo: incluir hooks

                                    // onChange={acao}
                              defaultValue={marca}
                              value={marca}
                              onChange={ (e) => alteraMarca(e) }
                          />
                      </FormControl>
                  </Grid>


                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl}>
                          <PneuModeloSelector
                              //todo: incluir hooks
                              // value={valor original}
                              // onChange={acao}
                              defaultValue={modId}
                              value={modelo}
                              onChange={e => { console.log("FullDialog.Modelo.onchange", e); setModelo(e)}}
                              marcaId={mId}
                          />
                      </FormControl>
                  </Grid>

                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl}>
                          <PneuMedidaSelector
                              //todo: incluir hooks
                              // value={valor original}
                              // onChange={acao}
                              defaultValue={medId}
                              value={medida}
                              onChange={e => { console.log("FullDialog.Medida.onchange", e); setMedida(e)}}
                          />
                      </FormControl>
                  </Grid>

                  <Grid item xs={12} md={3}  lg={3} container>
                      <FormControl className={classes.formControl}>
                          <BandaSelector
                              //todo: incluir hooks
                              // value={valor original}
                              // onChange={acao}
                              defaultValue={banId}
                              value={banda}
                              onChange={e => { console.log("FullDialog.Medida.onchange", e); setBanda(e)}}
                          />
                      </FormControl>
                  </Grid>
              </Grid>

                <Grid item xs={12} md={12} lg={12} className={classes.row} container>

                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="dot" className={classes.relative}>
                                dot
                            </InputLabel>
                            <TextField
                                id="dot"
                                label=""
                                type="text"
                                className={classes.textControl}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                value={dot}
                                onChange={e=> setDot(e.target.value)}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}  lg={3} container>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="marcaFogo" className={classes.relative}>
                                Marca de Fogo
                            </InputLabel>
                            <TextField
                                id="dot"
                                label=""
                                type="text"
                                className={classes.textControl}
                                readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}
                                value={marcaFogo}
                                onChange={e=> setMarcaFogo(e.target.value)}
                            />
                            {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                        </FormControl>
                    </Grid>
              {/*<Grid item xs={12} md={12} lg={12} className={classes.row} container>*/}
              {/*  /!*<Grid item xs={12} md={6}  lg={8} container>*!/*/}
              {/*  /!*  <FormControl className={classes.formControl}>*!/*/}
              {/*  /!*    <InputLabel shrink htmlFor="descricao" className={classes.relative}>*!/*/}
              {/*  /!*      descricao*!/*/}
              {/*  /!*    </InputLabel>*!/*/}
              {/*  /!*    <TextField*!/*/}
              {/*  /!*      id="descricao"*!/*/}
              {/*  /!*      label=""*!/*/}
              {/*  /!*      type="text"*!/*/}
              {/*  /!*      className={classes.textControl}*!/*/}
              {/*  /!*      value={descricao}*!/*/}
              {/*  /!*      readOnly={selectedRow && selectedRow.osJustToBackup === osCodigo}*!/*/}
              {/*  /!*      onChange={e => setDescricao(e.target.value)}*!/*/}
              {/*  /!*    />*!/*/}
              {/*  /!*    /!*<FormHelperText>Label + placeholder</FormHelperText>*!/*!/*/}
              {/*  /!*  </FormControl>*!/*/}
              {/*  /!*</Grid>*!/*/}
              {/*</Grid>*/}

            </Grid>
            </Grid>
          </Grid>
            {/*<Grid item xs={12} md={12} lg={12} className={classes.row} container>*/}
            {/*    <Grid item container>*/}
            {/*    <pre>*/}
            {/*    {JSON.stringify(orderDetails,null,4)}*/}
            {/*    </pre>*/}
            {/*    </Grid>*/}
            {/*</Grid>*/}

        </DialogContent>

          <DialogActions>
              <Grid item xs={12} md={12} lg={12} className={classes.row} container>
                  <Button onClick={handleSaveNew} color="default">
                      {msgButton}
                  </Button>
                  <Button onClick={handleClose} color="default">
                      Fechar
                  </Button>
              </Grid>
          </DialogActions>

      </Dialog>
    </div>
  );
}


export default (OrdemServicoAdd)
